<template>
    <div style="position: relative">
        <c-card-iterator
            :items          = "filteredItems"
            :label          = "$t('todo.sitedown.title')"
            :loading        = "loading"
            :title-prefix   = "true"
            :pagination-on  = "true"
            :item-height    = "76"
            :min-height     = "topHeight"
            :filter         = "match"
            :filter-height  = "72"
            :height         = "height"
            @search         = "onSearch"
        >
            <template v-slot:card="{ item }">
                <p-inc-site-down-card
                    :item = "item"
                    @site = "onSite"
                />
            </template>
        </c-card-iterator>
        <div v-if="(!items || items.length === 0) && !loading" class="lm-border empty-todos">
            <v-icon color="success" size="30">mdi-check-circle</v-icon>
        </div>
    </div>
</template>

<script>

import CCardIterator            from "@/modules/core/components/utils/CCardIterator.vue";
import PIncSiteDownCard         from "@/modules/inc/todos/components/private/PIncSiteDownCard.vue";
import IncTodoCardIteratorMixin from "@/modules/inc/todos/components/mixins/IncTodoCardIteratorMixin";

export default {
    name: "PIncSiteDownIterator",

    components: {
        PIncSiteDownCard,
        CCardIterator
    },

    mixins: [
        IncTodoCardIteratorMixin
    ],

    mounted () {
        this.initialize();
    },

    methods: {
        initialize () {
            this.load("SITEDOWN");
        },
    }
}
</script>

<style scoped>

</style>